module.exports = __webpack_public_path__ + "main/assets/public/event/icon-link.de02912def361f83.svg";